import React, { createContext, useContext, useEffect, useState } from "react";

const STRINGS = {
  en: {
    // Common
    "common.signin": "Sign in",
    "common.signup": "Patient sign up",
    "common.create_account": "Create your account",
    "common.signout": "Sign out",
    "common.back": "Back",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.send": "Send",
    "common.confirm": "Confirm",
    "common.language": "Language",
    // Landing
    "landing.tagline": "Unchwa, GKP — Since Day One",
    "landing.hero_pre": "Care that listens.",
    "landing.hero_title": "Dr Tayyeb's Dental & Maxillofacial Centre.",
    "landing.hero_body": "Modern dental & maxillofacial care in Unchwa, Gorakhpur. Book online, track your treatment, and own your dental health journey.",
    "landing.cta_book": "Book an appointment",
    "landing.cta_signin": "Sign in",
    "landing.section_book_title": "Request your visit",
    "landing.section_book_subtitle": "Tell us a bit about you and the reason for your visit — we'll confirm your slot shortly.",
    "landing.field_name": "Full name",
    "landing.field_phone": "Phone",
    "landing.field_email": "Email (optional)",
    "landing.field_service": "What treatment / concern?",
    "landing.field_preferred": "Preferred date",
    "landing.field_message": "Tell us more (optional)",
    "landing.placeholder_service": "e.g. Toothache, Implant consult, Orthodontics",
    "landing.submit": "Request appointment",
    "landing.success_title": "Request received",
    "landing.success_body": "Thank you. Our team will contact you to confirm your appointment.",
    "landing.success_track": "Want to track your visits, treatment history and invoices?",
    "landing.signin_now": "Sign in",
    "landing.create_now": "Create patient account",
    "landing.continue": "Continue browsing",
    "landing.features_title": "Everything you need from your dentist.",
    "landing.feat_book": "Online booking",
    "landing.feat_book_body": "Pick your doctor, date and a free slot.",
    "landing.feat_history": "Treatment history",
    "landing.feat_history_body": "See every visit and treatment.",
    "landing.feat_invoices": "Invoices",
    "landing.feat_invoices_body": "Receipts and balances at a glance.",
    "landing.feat_chart": "Dental chart",
    "landing.feat_chart_body": "Your tooth-by-tooth status, visualised.",
    "landing.feat_reminders": "Smart reminders",
    "landing.feat_reminders_body": "SMS & WhatsApp so you never miss a visit.",
    "landing.feat_xray": "Records",
    "landing.feat_xray_body": "X-rays & photos stored securely.",

    // Portal
    "portal.greeting": "Hi",
    "portal.subtitle": "Your dental journey with Dr Tayyeb at a glance.",
    "portal.next_visit": "Next visit",
    "portal.treatments": "Treatments",
    "portal.outstanding": "Outstanding",
    "portal.not_scheduled": "Not scheduled",
    "portal.book_card_title": "Book an appointment",
    "portal.book_card_body": "Pick a doctor, date and time slot.",
    "portal.book_card_cta": "Start booking",
    "portal.appts_card_title": "My appointments",
    "portal.appts_card_body": "See upcoming and past visits.",
    "portal.history_card_title": "Treatment history",
    "portal.history_card_body": "Every procedure documented.",
    "portal.invoices_card_title": "Invoices",
    "portal.invoices_card_body": "Bills and payment status.",
    "portal.enquiry_card_title": "Request a consultation",
    "portal.enquiry_card_body": "Tell us what you need; we'll get back fast.",
    "portal.view": "View",
    "portal.open": "Open",
    "portal.start": "Start",
    "portal.nav_overview": "Overview",
    "portal.nav_book": "Book Appointment",
    "portal.nav_appts": "My Appointments",
    "portal.nav_history": "Treatment History",
    "portal.nav_invoices": "Invoices",
    "portal.nav_enquiry": "Request Consultation",

    // Book
    "book.title": "Book an appointment",
    "book.subtitle": "Pick a doctor, date and a time slot. We'll confirm via SMS / WhatsApp.",
    "book.step1": "Choose your doctor",
    "book.step2": "Pick a date",
    "book.step3": "Choose an open slot",
    "book.step4": "Anything we should know?",
    "book.no_slots": "No openings on this date. Try another day.",
    "book.field_treatment": "Treatment / concern (e.g. Cleaning, Implant consult)",
    "book.field_notes": "Any details (optional)",
    "book.confirm": "Confirm appointment",
    "book.booked": "Appointment booked! You'll receive a confirmation shortly.",
    "book.selected": "Selected",

    // Login / Register
    "login.tagline": "Secure Sign-In",
    "login.title": "Welcome back.",
    "login.subtitle": "Staff, doctors and patients - same door, different views.",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign in",
    "login.new_patient": "New patient?",
    "login.quick_accounts": "Quick test accounts",
    "register.tagline": "Patient sign-up",
    "register.title": "Create your patient portal.",
    "register.subtitle": "Book appointments, view your treatment history and invoices anytime.",
    "register.field_name": "Full name",
    "register.field_phone": "Phone (optional)",
    "register.field_password": "Password",
    "register.submit": "Create my account",
    "register.have_account": "I already have an account",
  },

  hi: {
    // Common
    "common.signin": "साइन इन करें",
    "common.signup": "मरीज़ रजिस्टर",
    "common.create_account": "अकाउंट बनाएँ",
    "common.signout": "लॉग आउट",
    "common.back": "वापस",
    "common.cancel": "रद्द करें",
    "common.save": "सेव करें",
    "common.send": "भेजें",
    "common.confirm": "पुष्टि करें",
    "common.language": "भाषा",
    // Landing
    "landing.tagline": "उँचवा, गोरखपुर — पहले दिन से",
    "landing.hero_pre": "देखभाल, जो आपकी सुने।",
    "landing.hero_title": "डॉ. तय्यब डेंटल और मैक्सिलोफेशियल सेंटर।",
    "landing.hero_body": "उँचवा, गोरखपुर में आधुनिक दंत एवं मैक्सिलोफेशियल चिकित्सा। ऑनलाइन अपॉइंटमेंट लें, अपना इलाज ट्रैक करें, और अपनी दंत स्वास्थ्य यात्रा पर पूरा नियंत्रण रखें।",
    "landing.cta_book": "अपॉइंटमेंट बुक करें",
    "landing.cta_signin": "साइन इन",
    "landing.section_book_title": "अपनी विज़िट का अनुरोध करें",
    "landing.section_book_subtitle": "अपना नाम, संपर्क और परेशानी बताइए — हम जल्द ही आपका स्लॉट कन्फ़र्म कर देंगे।",
    "landing.field_name": "पूरा नाम",
    "landing.field_phone": "मोबाइल नंबर",
    "landing.field_email": "ईमेल (वैकल्पिक)",
    "landing.field_service": "किस इलाज की ज़रूरत है?",
    "landing.field_preferred": "पसंदीदा तारीख़",
    "landing.field_message": "और जानकारी (वैकल्पिक)",
    "landing.placeholder_service": "जैसे दाँत दर्द, इम्प्लांट सलाह, ब्रेसेस",
    "landing.submit": "अपॉइंटमेंट का अनुरोध करें",
    "landing.success_title": "अनुरोध प्राप्त हुआ",
    "landing.success_body": "धन्यवाद! हमारी टीम जल्द ही आपसे संपर्क करेगी और अपॉइंटमेंट कन्फ़र्म करेगी।",
    "landing.success_track": "क्या आप अपनी विज़िट्स, इलाज और बिलिंग ट्रैक करना चाहते हैं?",
    "landing.signin_now": "साइन इन करें",
    "landing.create_now": "मरीज़ अकाउंट बनाएँ",
    "landing.continue": "और देखें",
    "landing.features_title": "वो सब कुछ जो आपको अपने डेंटिस्ट से चाहिए।",
    "landing.feat_book": "ऑनलाइन बुकिंग",
    "landing.feat_book_body": "अपने डॉक्टर, तारीख़ और खाली स्लॉट चुनें।",
    "landing.feat_history": "इलाज का इतिहास",
    "landing.feat_history_body": "हर विज़िट और हर इलाज एक जगह।",
    "landing.feat_invoices": "बिल / इनवॉइस",
    "landing.feat_invoices_body": "रसीदें और बकाया एक नज़र में।",
    "landing.feat_chart": "डेंटल चार्ट",
    "landing.feat_chart_body": "आपके हर दाँत की स्थिति विज़ुअल रूप में।",
    "landing.feat_reminders": "स्मार्ट रिमाइंडर",
    "landing.feat_reminders_body": "SMS और WhatsApp से कोई विज़िट न छूटे।",
    "landing.feat_xray": "रिकॉर्ड",
    "landing.feat_xray_body": "X-ray और फ़ोटो सुरक्षित रखे जाते हैं।",

    // Portal
    "portal.greeting": "नमस्ते",
    "portal.subtitle": "डॉ. तय्यब के साथ आपकी दंत यात्रा एक नज़र में।",
    "portal.next_visit": "अगली विज़िट",
    "portal.treatments": "इलाज",
    "portal.outstanding": "बकाया",
    "portal.not_scheduled": "अभी तय नहीं",
    "portal.book_card_title": "अपॉइंटमेंट बुक करें",
    "portal.book_card_body": "डॉक्टर, तारीख़ और समय चुनें।",
    "portal.book_card_cta": "बुकिंग शुरू करें",
    "portal.appts_card_title": "मेरी अपॉइंटमेंट्स",
    "portal.appts_card_body": "आगामी और पिछली विज़िट देखें।",
    "portal.history_card_title": "इलाज का इतिहास",
    "portal.history_card_body": "हर प्रक्रिया का दस्तावेज़।",
    "portal.invoices_card_title": "इनवॉइस",
    "portal.invoices_card_body": "बिल और भुगतान की स्थिति।",
    "portal.enquiry_card_title": "सलाह का अनुरोध",
    "portal.enquiry_card_body": "हमें बताइए, हम जल्दी संपर्क करेंगे।",
    "portal.view": "देखें",
    "portal.open": "खोलें",
    "portal.start": "शुरू करें",
    "portal.nav_overview": "ओवरव्यू",
    "portal.nav_book": "अपॉइंटमेंट बुक करें",
    "portal.nav_appts": "मेरी अपॉइंटमेंट्स",
    "portal.nav_history": "इलाज का इतिहास",
    "portal.nav_invoices": "इनवॉइस",
    "portal.nav_enquiry": "सलाह का अनुरोध",

    // Book
    "book.title": "अपॉइंटमेंट बुक करें",
    "book.subtitle": "डॉक्टर, तारीख़ और टाइम स्लॉट चुनें। हम SMS / WhatsApp पर कन्फ़र्म करेंगे।",
    "book.step1": "अपने डॉक्टर चुनें",
    "book.step2": "तारीख़ चुनें",
    "book.step3": "एक खाली स्लॉट चुनें",
    "book.step4": "कुछ और बताना चाहेंगे?",
    "book.no_slots": "इस तारीख़ पर कोई स्लॉट खाली नहीं है। दूसरी तारीख़ देखें।",
    "book.field_treatment": "इलाज / समस्या (जैसे सफ़ाई, इम्प्लांट सलाह)",
    "book.field_notes": "कोई और जानकारी (वैकल्पिक)",
    "book.confirm": "अपॉइंटमेंट कन्फ़र्म करें",
    "book.booked": "अपॉइंटमेंट बुक हो गई! आपको जल्द ही कन्फ़र्मेशन मिलेगा।",
    "book.selected": "चयनित",

    // Login / Register
    "login.tagline": "सुरक्षित साइन-इन",
    "login.title": "वापसी पर स्वागत है।",
    "login.subtitle": "स्टाफ़, डॉक्टर और मरीज़ — एक ही दरवाज़ा, अलग व्यू।",
    "login.email": "ईमेल",
    "login.password": "पासवर्ड",
    "login.submit": "साइन इन",
    "login.new_patient": "नए मरीज़?",
    "login.quick_accounts": "टेस्ट अकाउंट्स",
    "register.tagline": "मरीज़ रजिस्ट्रेशन",
    "register.title": "अपना मरीज़ पोर्टल बनाएँ।",
    "register.subtitle": "कभी भी अपॉइंटमेंट बुक करें, अपना इलाज और बिल देखें।",
    "register.field_name": "पूरा नाम",
    "register.field_phone": "मोबाइल नंबर (वैकल्पिक)",
    "register.field_password": "पासवर्ड",
    "register.submit": "अकाउंट बनाएँ",
    "register.have_account": "मेरा पहले से अकाउंट है",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");
  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);
  const t = (key) => (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.en[key] || key;
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) return { lang: "en", setLang: () => {}, t: (k) => STRINGS.en[k] || k };
  return ctx;
}

export function LangSwitch({ className = "", dark }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex border rounded-sm overflow-hidden ${dark?"border-zinc-700":"border-zinc-300"} ${className}`} data-testid="lang-switch">
      {[["en","EN"], ["hi","हिं"]].map(([k, label]) => (
        <button key={k} onClick={()=>setLang(k)}
          className={`px-2 py-1 text-[11px] uppercase tracking-wider font-bold transition-colors ${
            lang===k
              ? (dark?"bg-white text-zinc-900":"bg-zinc-900 text-white")
              : (dark?"text-zinc-400 hover:text-white":"text-zinc-600 hover:text-zinc-900")
          }`}
          data-testid={`lang-${k}`}>
          {label}
        </button>
      ))}
    </div>
  );
}
